import React, { useContext, useState, useEffect, Fragment } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Button from "react-bootstrap/Button";

import MainLogo from "../Assets/Img/Logo-stringing-180-white.png";
import { MenuOptions } from "./Texts";
import AppContext from "./AppContext";

const LanguagePicker = () => {
	const context = useContext(AppContext);
	return (
		<Button
			variant="outline-light"
			size="sm"
			className="nav-lang-btn"
			href={context.lang.get === "de" ? "/" : "/index-en.htm"}
		>
			{context.lang.get === "de" ? "DE" : "EN"}
		</Button>
	);
};

const Navigation = () => {
	const context = useContext(AppContext);
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const onScroll = () => setScrolled(window.scrollY > 60);
		window.addEventListener("scroll", onScroll, { passive: true });
		return () => window.removeEventListener("scroll", onScroll);
	}, []);

	return (
		<Fragment>
			<div style={{ height: "58px" }} />
			<Navbar
				id="navbar"
				collapseOnSelect
				expand="lg"
				variant="dark"
				fixed="top"
				className={`site-navbar${scrolled ? " site-navbar--scrolled" : ""}`}
			>
				<Navbar.Brand href="#home" className="site-navbar__brand">
					<img
						alt="Besaitung.ch"
						src={MainLogo}
						width="28"
						height="28"
						className="site-navbar__logo"
					/>
					<span className="site-navbar__title">BESAITUNG.CH</span>
				</Navbar.Brand>

				<Navbar.Toggle aria-controls="main-nav" className="site-navbar__toggler" />

				<Navbar.Collapse id="main-nav">
					<Nav className="ms-auto align-items-lg-center gap-lg-1">
						{MenuOptions.map((item, i) => (
							<Nav.Link key={i} href={item.ancor} className="site-navbar__link">
								{context.lang.get === "en" ? item.string_DE : item.string_ENG}
							</Nav.Link>
						))}
						<div className="ms-lg-3 mt-2 mt-lg-0">
							<LanguagePicker />
						</div>
					</Nav>
				</Navbar.Collapse>
			</Navbar>
		</Fragment>
	);
};

export default Navigation;
